import {appApi} from "@services/api.service";
import {ReportProblemApiFormat} from "@models/helpdesk/reportProblem";
import {Preferences} from "@capacitor/preferences";
import {ReportApplicationApiFormat} from "@models/helpdesk/reportApplication";
import {DataSelectable} from "@models/common";
import {Application} from "@app/helpdesk/reportApplication/panes/reportApplicationListPane.component";

const endpointPrefix = 'helpdesk';

const reportProblem = async (reportProblemData: ReportProblemApiFormat) => {
    const profileId = await Preferences.get({'key': 'profile_id'});

    return await appApi.post(`${endpointPrefix}/report-problem` + (profileId.value !== 'undefined' ? `?profileId=${profileId.value}` : ''), reportProblemData);
}

const getReportApplications = async (): Promise<Application[]> => {
    const response: any = await appApi.get(`${endpointPrefix}/report-applications`);

    return response.data;
}

const getReportApplicationPreview = async (applicationId: number) => {
    return await appApi.get(`${endpointPrefix}/report-application-preview/${applicationId}`);
}

const reportApplication = async (reportApplicationData: ReportApplicationApiFormat) => {
    const profileId = await Preferences.get({'key': 'profile_id'});

    return await appApi.post(`${endpointPrefix}/report-application` + (profileId.value !== 'undefined' ? `?profileId=${profileId.value}` : ''), reportApplicationData);
}

const getWorkerClients = async (date: string, page: number = 1, searchText: string = ''): Promise<DataSelectable[]> => {
    const response: any = await appApi.get(`worker-clients?page=${page}&searchText=${searchText}&date=${date}`);

    return response.data;
}

const getWorkerOrders = async (client: number, page: number = 1, searchText: string = ''): Promise<DataSelectable[]> => {
    const response: any = await appApi.get(`worker-orders?page=${page}&searchText=${searchText}&client=${client}`);

    return response.data;
}

const getWorkerReports = async (order: number, page: number = 1, searchText: string = ''): Promise<DataSelectable[]> => {
    const response: any = await appApi.get(`reports/worker-reports?page=${page}&searchText=${searchText}&order=${order}`);

    return response.data;
}

export {
    getWorkerClients,
    getWorkerOrders,
    getWorkerReports,
    reportProblem,
    getReportApplications,
    getReportApplicationPreview,
    reportApplication,
};
